import { render } from "./findpeopleDetail.vue?vue&type=template&id=729b4784&scoped=true"
import script from "./findpeopleDetail.vue?vue&type=script&lang=js"
export * from "./findpeopleDetail.vue?vue&type=script&lang=js"

import "./findpeopleDetail.vue?vue&type=style&index=0&id=729b4784&lang=less&scoped=true"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-729b4784"]])

export default __exports__